// extracted by mini-css-extract-plugin
export var actionButton = "_de-t";
export var buttonContainer = "_de-0";
export var buttonContainer2 = "_de-1";
export var buttonSection = "_de-2";
export var details = "_de-3";
export var dropdownItem = "_de-5";
export var dropdownItemsContainer = "_de-4";
export var fileInput = "_de-r";
export var headerButton = "_de-6";
export var icon = "_de-7";
export var input = "_de-8";
export var macroListItem = "_de-9";
export var mainContent = "_de-a";
export var microText = "_de-b";
export var modal = "_de-w";
export var optionsButton = "_de-c";
export var paperclip = "_de-s";
export var pillContent = "_de-d";
export var preview = "_de-e";
export var preview2 = "_de-f";
export var quillEditor = "_de-q";
export var selectedMacro = "_de-g";
export var sidebar = "_de-h";
export var sidebarHeader = "_de-j";
export var sidebarList = "_de-i";
export var sidebarListItem = "_de-k";
export var sidebarSearch = "_de-l";
export var snoozeDurationWrapper = "_de-v";
export var statusPillContainer = "_de-m";
export var tagsContainer = "_de-n";
export var unselectedMacro = "_de-o";
export var variable = "_de-u";
export var wrapper = "_de-p";